import * as yup from 'yup';
import { useTranslation } from 'react-i18next';

export const useInternalUserSchema = () => {
  const { t } = useTranslation();
  const requiredError = t('errors.required');

  return yup.object({
    firstName: yup.string().required(requiredError),
    lastName: yup.string().required(requiredError),
    email: yup.string().required(requiredError),
    userType: yup.string().required(requiredError),
  });
};
